import { useState } from "react";
import { stripHtml } from "@/utils/format";

interface Review {
  id: number;
  avatar: string;
  name: string;
  rating: number;
  date: string;
  content: string;
}

interface ReviewsProps {
  reviews: Review[];
  reviewCount: number;
}

export default function Reviews({ reviews, reviewCount }: ReviewsProps) {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="bg-white mt-2 px-5 py-4">
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm font-semibold text-gray-800">用户评价</div>
        <button onClick={() => setShowAll(!showAll)} className="text-xs cursor-pointer" style={{ color: "#1E3A8A" }}>
          {showAll ? "收起" : `查看全部 ${reviewCount} 条`}
        </button>
      </div>
      <div className="space-y-4">
        {reviews.slice(0, showAll ? undefined : 2).map((r) => (
          <ReviewItem key={r.id} {...r} />
        ))}
      </div>
    </div>
  );
}

function ReviewItem({ avatar, name, rating, date, content }: Review) {
  return (
    <div className="pb-4 border-b border-gray-100 last:border-0">
      <div className="flex items-center gap-2 mb-2">
        <img src={avatar} alt={name} className="w-8 h-8 rounded-full object-cover" />
        <div className="flex-1 min-w-0">
          <div className="text-xs font-semibold text-gray-800">{name}</div>
          <div className="flex items-center gap-1">
            {[1,2,3,4,5].map(s => (
              <i key={s} className="ri-star-fill" style={{ color: s <= rating ? "#F59E0B" : "#E5E7EB", fontSize: 10 }} />
            ))}
            <span className="text-xs text-gray-400 ml-1">{date}</span>
          </div>
        </div>
      </div>
      <p className="text-xs text-gray-600 leading-relaxed">{stripHtml(content)}</p>
    </div>
  );
}
